import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-801de766"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "board_graph_list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chart = _resolveComponent("Chart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.active, (data) => {
      return (_openBlock(), _createBlock(_component_Chart, {
        style: {"height":"150px"},
        defaultLayout: $setup.activeChartLayout,
        data: data
      }, null, 8, ["defaultLayout", "data"]))
    }), 256)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.platform, (data) => {
      return (_openBlock(), _createBlock(_component_Chart, {
        style: {"height":"380px"},
        defaultLayout: $setup.platformChartLayout,
        data: data
      }, null, 8, ["defaultLayout", "data"]))
    }), 256)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.gubun, (data) => {
      return (_openBlock(), _createBlock(_component_Chart, {
        style: {"height":"380px"},
        defaultLayout: $setup.gubunChartLayout,
        data: data
      }, null, 8, ["defaultLayout", "data"]))
    }), 256)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.industry, (data) => {
      return (_openBlock(), _createBlock(_component_Chart, {
        style: {"height":"380px"},
        defaultLayout: $setup.industryChartLayout,
        data: data
      }, null, 8, ["defaultLayout", "data"]))
    }), 256)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chartData.doubt, (data) => {
      return (_openBlock(), _createBlock(_component_Chart, {
        style: {"height":"150px"},
        defaultLayout: $setup.doubtChartLayout,
        data: data
      }, null, 8, ["defaultLayout", "data"]))
    }), 256))
  ]))
}